import {
  IApplyForPublicationOptions,
  IApplyForPublicationResponse200,
  IApplyForPublicationResponse400,
  fetchApplyForPublication,
} from '../repositories/coworking/v1/apply-for-publication';

import { useFetch } from './useFetch';

export function useFetchPostApplyForPublication() {
  return useFetch<
    IApplyForPublicationResponse200,
    IApplyForPublicationResponse400,
    Omit<IApplyForPublicationOptions<IApplyForPublicationResponse200, IApplyForPublicationResponse400>, 'httpApi'>
  >(fetchApplyForPublication, 'Ошибка при запросе на бронирование коворкинга');
}
